import Examination from "../../models/Examination";
import { requestFactory } from "@socotec.io/socio-vue-components";
import { setDisplayedItems } from "@/utils/setDisplayedItems";
import { list, listAll, retrieve } from "@/utils/factoryRest";
import { ExaminationApi } from "@socotec.io/certipers-back-sdk";
import configs from "@/setup/openApiConfig";
import { defineStore } from "pinia";
import { useRepo } from "pinia-orm";

const examinationsRepo = useRepo(Examination);
const examinationApi = new ExaminationApi(configs.certipersBackConfig);

export const formatExamination = (examination) => {
  return {
    ...examination,
    stepUuid: examination.step,
  };
};

export const useExaminationStore = defineStore("examination", {
  state: () => ({
    examinationsCount: 0,
  }),

  actions: {
    fetchExaminations: list({
      ModelRepo: examinationsRepo,
      restListMethod: examinationApi.list.bind(examinationApi),
      handleResponseData: ({ results }) => {
        return results.map(formatExamination);
      },
      onItemsInserted: (responseData) => {
        useExaminationStore().setExaminationsCount(responseData.count);
        setDisplayedItems(examinationsRepo, responseData.results);
      },
    }),

    async fetchAllExaminations({ filters = {} } = {}) {
      const results = await listAll(examinationApi.list.bind(examinationApi), filters);

      this.setExaminationsCount(results.length);
      const examinations = examinationsRepo.save(results.map(formatExamination));
      setDisplayedItems(examinationsRepo, results);

      return examinations;
    },

    retrieveExamination: retrieve({
      ModelRepo: examinationsRepo,
      restRetrieveMethod: examinationApi.retrieveWithDomain.bind(examinationApi),
      handleResponseData: (response) => {
        return formatExamination(response);
      },
    }),

    setExaminationsCount(count) {
      this.examinationsCount = count;
    },
  },

  getters: {
    getExaminationsCount: (state) => state.examinationsCount,
    getExaminations: () => {
      return requestFactory.getters.paginateGetter(
        examinationsRepo.orderBy("createdAt", "desc").withAll(),
      );
    },
    getExaminationDisplayed: () => {
      return examinationsRepo
        .where("isDisplayed", true)
        .with("scenarios", (query) => {
          query.where("isPublished", true).where("isArchived", false); // INFO - AG 27/07/2023 - Implement here the same filter as in back api to prevent render when a scenario is just create.
        })
        .with("examinationDecisions")
        .first();
    },
    getAllExaminations: () => {
      return examinationsRepo.all();
    },
  },
});
